import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media only screen and (max-width: 1200px) {
    flex-direction: column;
    justify-content: center;
    row-gap: 10px;
  }

  .type {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: ${colors.white};
    font-weight: 600;
    font-size: 16px;
    white-space: nowrap;
    letter-spacing: 1px;

    .icon {
      margin-left: 5px;
      cursor: pointer;
    }

    .grey {
      color: ${colors.grey};
      margin-right: 10px;
    }
  }
  
  ${({ additionalstyle }) => additionalstyle};
`;
